import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Footer.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Header.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Text/Text.tsx")